import { useState } from 'react';
export default function useAsync(getData, initialState) {
    const [state, setState] = useState('dormant');
    const [userState, setUserState] = useState(initialState);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const setPending = (p) => {
        setState('pending');
        p
            .then(data => {
            setState('resolved');
            setData(data);
        })
            .catch(error => {
            setState('rejected');
            setError(error);
        });
    };
    if (state === 'dormant') {
        setPending(getData());
    }
    return (view) => {
        switch (state) {
            case 'resolved':
                return view.resolved(data, userState, (p, newState) => {
                    setUserState(newState);
                    setPending(p);
                });
            case 'rejected':
                return view.rejected(error, userState, (p, newState) => {
                    setUserState(newState);
                    setPending(p);
                });
            default:
                return view.pending(userState);
        }
    };
}
